/* Print guard (4.11.2026): a Custom Print line can never be bought without its shirts.
   After every cart change, each print line is matched to the shirts that carry the same "Print job".
   No shirts left -> the print line is removed. Fewer/more shirts -> the print quantity follows them. */
(function () {
  var busy = false, origFetch = window.fetch.bind(window);

  function check() {
    if (busy) return Promise.resolve();
    busy = true;
    return origFetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var shirts = {}, fixes = {};
        cart.items.forEach(function (it) {
          var job = it.properties && it.properties['Print job'];
          if (job && it.handle !== 'custom-print') shirts[job] = (shirts[job] || 0) + it.quantity * packOf(it);
        });
        cart.items.forEach(function (it) {
          if (it.handle !== 'custom-print') return;
          var job = it.properties && it.properties['Print job'];
          var want = job ? (shirts[job] || 0) : 0;
          if (it.quantity !== want) fixes[it.key] = want;
        });
        if (!Object.keys(fixes).length) return;
        return origFetch('/cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: fixes })
        }).then(function () { window.location.reload(); });
      })
      .catch(function (e) { console.error('va-print-guard', e); })
      .then(function () { busy = false; });
  }

  // Pack products count several shirts per unit ("Pack of 3" etc.), matching the print tool's own count.
  function packOf(it) {
    var o = (it.options_with_values || []).find(function (x) { return /pack/i.test(x.name); });
    return o ? (parseInt(o.value, 10) || 1) : 1;
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch(input, init);
    if (/\/cart\/(change|update|clear)/.test(url)) p.then(function () { setTimeout(check, 300); });
    return p;
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check);
  else check();
})();
